<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="450"
    transition="spin-in-out-transition"
  >
    <v-card class="position-relative">
      <v-btn
        class="primary elevation-1 rounded-lg position-absolute top-2 right-2"
        min-width="40"
        max-width="40"
        style="color: rgb(0, 0, 0)"
        text
        @click="show = false"
      >
        <v-icon color="black" @click="show = false"> mdi-close </v-icon>
      </v-btn>
      <div class="block-center">
        <v-img src="@/assets/image/logo.png" class="logo-img" />
      </div>
      <div class="block-text-sys">{{ $t('common.system_notify') }}</div>
      <hr class="hr-dashed" />
      <v-card-title class="headline">
        {{ oldTitle }}
      </v-card-title>
      <v-card-text style="white-space: pre-wrap">{{ oldMessage }}</v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import templateMixin from './templateMixin';

export default {
  mixins: [templateMixin],
  props: {
    oldTitle: {
      required: true,
    },
    oldMessage: {
      required: true,
    },
  },
  name: 'DefaultNotification',
};
</script>

<style scoped>
.logo-img {
  max-width: 100px;
  margin-top: 10px;
}
.block-center {
  display: flex;
  justify-content: center;
  justify-items: center;
}
.block-text-sys {
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  margin-top: 10px;
}
.hr-dashed {
  border: 1px dashed;
  margin: 10px 24px 0 24px;
}
</style>
